import { LINK_CUSTOMER, LINK_CUSTOMER_SUCCESS, LINK_CUSTOMER_ERROR, LINK_CUSTOMER_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const LinkCustomer = (state = initialState, action) => {
  switch (action.type) {
    case LINK_CUSTOMER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LINK_CUSTOMER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LINK_CUSTOMER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LINK_CUSTOMER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default LinkCustomer;
